import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FeedbackService} from '../_service/service.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
    data2 = {};

    date = new Date();
    subject = '';
    message = '';
    show = false;

    loader = 'content';

    constructor(private modalService: NgbModal, private feedbackService: FeedbackService, private router: Router) {
    }

    ngOnInit(): void {
        this.subject = '';
        this.message = '';
    }

    openVerticallyCentered(content) {
        this.loader = 'content';
        this.modalService.open(content, {centered: true});
    }

    onSubmit() {
        this.data2 = {
            subject: this.subject,
            message: this.message,
            linkURL: this.router.url,
            date: this.date
        };

        if (this.subject !== '' && this.message !== '') {
            this.feedbackService.onPostFeedback(this.data2).subscribe(() => {
                
                this.loader = 'valid';
                this.subject = '';
                this.message = '';
                setTimeout(() => {
                    this.loader = '';
                    this.modalService.dismissAll();
                }, 5000);
            }, () => {
                this.loader = 'error';
                setTimeout(() => {
                    this.loader = 'content';
                }, 3000);
            });
        } else {
            this.loader = 'invalid';
        }
    }
}
